import {Controller} from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";
import {Modal} from "bootstrap";

export default class extends Controller {
    private modalElement: Modal | null = null;

    connect() {
        console.log('Modal content controller connected');
        this.modalElement = new bootstrap.Modal(
            this.element, {
                backdrop: 'static',
                keyboard: false
            });

        this.element.addEventListener('hidePrevented.bs.modal', this.close.bind(this));
    }

    disconnect() {
        this.modalElement?.dispose();
    }

    open() {
        // event.preventDefault();
        this.modalElement?.show();
    }

    close() {
        this.modalElement?.hide();
    }
}